/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_Unit_PriceInputs */

const vi_fertilizer_unit_price = /** @type {(inputs: Fertilizer_Unit_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn giá`)
};

/**

* @param {Fertilizer_Unit_PriceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_unit_price = /** @type {((inputs?: Fertilizer_Unit_PriceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_Unit_PriceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_unit_price(inputs)
});